import type { ReactNode } from "react";
import { Text, View } from "react-native";

export function FormField({
  label,
  error,
  helper,
  required,
  theme = "light",
  children,
}: {
  label: string;
  error?: string;
  helper?: string;
  required?: boolean;
  theme?: "light" | "dark";
  children: ReactNode;
}) {
  const labelCls =
    theme === "dark"
      ? "mb-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white/60"
      : "mb-1 text-[10px] font-bold uppercase tracking-[0.16em] text-text/65";
  const helperCls =
    theme === "dark"
      ? "mb-1 text-[11px] text-white/45"
      : "mb-1 text-[11px] text-text/55";
  return (
    <View className="w-full">
      <Text className={labelCls} style={{ fontFamily: "DMSans_700Bold" }}>
        {label}
        {required ? <Text style={{ color: "#B91C1C" }}> *</Text> : null}
      </Text>
      {helper ? (
        <Text className={helperCls} style={{ fontFamily: "DMSans_400Regular" }}>
          {helper}
        </Text>
      ) : null}
      {children}
      {error ? (
        <Text className="mt-1 text-[12px] text-error-bright" style={{ fontFamily: "DMSans_400Regular" }}>
          {error}
        </Text>
      ) : null}
    </View>
  );
}
